export class DayOfList {
    isNewMonth : boolean;
    date : Date;
    sessionCount : number;

}
